
import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, Input, model, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { IObjectAddress, IPlatformUser } from "@nova/common-interfaces";
import { IServicePlan } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { StepperModule } from "primeng/stepper";
import { AuthenticatedHeaderComponent } from "../../../shared/components/auth/authenticated-header/authenticated-header.component.mjs";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { OrderAddressComponent } from "../../components/address/address.component";
import { OrderInternetPlanComponent } from "../../components/internet-plan/internet-plan.component";
import { OrderReviewComponent } from "../../components/review/review.component";
import { IPersonDetails, OrderSetupPlanComponent } from "../../components/setup-plan/setup-plan.component";
import { ThankYouComponent } from "../../components/thank-you/thank-you.component";
import { OrderSidebarComponent } from "../../layouts/order-sidebar/order-sidebar.component";

export interface IGeographicalInformation {
  longitude: number,
  latitude: number;
}

@Component({
  selector: "app-order-dashboard",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    StepperModule,
    OrderAddressComponent,
    OrderInternetPlanComponent,
    OrderSetupPlanComponent,
    ThankYouComponent,
    OrderReviewComponent,
    OrderSidebarComponent,
    AuthenticatedHeaderComponent
  ],
  templateUrl: "./order-dashboard.component.html",
  styleUrl: "./order-dashboard.component.scss",
  encapsulation:ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrderDashboardComponent implements OnInit {
  isToggled = false;
  @Input()
  user: IPlatformUser | undefined;

  address = model<IObjectAddress>({} as IObjectAddress);
  selectedPlan = model<IServicePlan>();
  personalDetails = model<IPersonDetails>({} as IPersonDetails);
  termsAccepted = model<boolean>(false);
  geographical_information = model<IGeographicalInformation | undefined>();

  
  @Input() activateCallback!: (step: number) => void;
  orderSaved: boolean = false;

handleToggle(newState: boolean) {
    this.isToggled = newState;
  }

  constructor(router: Router, private authService: AuthService) {

    effect(() => {
      if (this.orderSaved)
      {

      }
    });
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.user = { ...user } as unknown as IPlatformUser;
      }
    });
  }
  ngOnInit(): void {
    this.address.set({} as IObjectAddress);
  }

  goToNextStep() {
    if (this.activateCallback) {
      this.activateCallback(3); // Example usage of the function
    }
  }
}
